import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import "./WhatYouGet.scss";

const benefits = [
  { id: "commission", width: 209 },
  { id: "referral", width: 222 },
  { id: "dashboard", width: 222 },
  { id: "marketing", width: 245 },
  { id: "manager", width: 239 },
  { id: "bonuses", width: 273 },
];

function WhatYouGet() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        // Թող browser-ը նախ render անի initial hidden state-ը,
        // հետո ավելացնենք visible class-ը, որպեսզի transition-ը երևա։
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            section.classList.add("is-visible");
          });
        });

        // Animation-ը միայն մեկ անգամ
        observer.unobserve(section);
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -20% 0px",
      }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="partnership-benefits"
      aria-labelledby="partnership-benefits-title"
    >
      <div className="partnership-benefits__inner">
        <header className="partnership-benefits__header">
          <h2 id="partnership-benefits-title">
            {t("partnership.benefits.title")}
          </h2>

          <p>{t("partnership.benefits.description")}</p>

          <span
            className="partnership-benefits__accent"
            aria-hidden="true"
          />
        </header>

        <div className="partnership-benefits__grid">
          {benefits.map(({ id, width }, index) => (
            <article
              className={`partnership-benefits__card partnership-benefits__card--${id}`}
              style={{
                "--card-index": index,
              }}
              key={id}
            >
              <div
                className="partnership-benefits__illustration"
                style={{
                  "--illustration-width": `${width}px`,
                }}
              >
                <img
                  src={`/assets/images/partnership/${id}.png`}
                  alt=""
                  width={width}
                  height="186"
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="partnership-benefits__copy">
                <h3>
                  {t(`partnership.benefits.${id}.title`)}
                </h3>

                <p>
                  {t(`partnership.benefits.${id}.description`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhatYouGet;